import fieldType from '@/enums/fieldType'
import i18n from "../vuei18n"

const SEPARATOR=";"
const LINE_BREAK="\n"

export default class Csv {
    constructor(schema) {
        this.csv = ''
        this.schema = schema
    }

    static printFromString(string, fileName = 'file') {
        let content = 'data:text/csv;charset=utf-8,' + string
        let encodedUri = encodeURI(content)
        let link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', fileName + '.csv')
        document.body.appendChild(link)
        link.click()
    }

    save() {
        return this.constructor.printFromString(this.csv, this.schema.name)
    }

    loadFormRecods(forms) {
        forms.forEach(form => {
            this.loadForm(form)
        })
        return this
    }

    loadForm(form) {
        for (let i = 0; i < this.getMaxDeph(form); i++) {
            this.schema.fields.forEach(field => {
                let formField = form.results.find(result => result.order == field.order)
                if (field.type != fieldType.TABLE) {
                    this.csv += this.getCustomFieldResult(i, formField)
                } else {
                    if (formField.value.length <= i) {
                        this.csv += Array(field["sub-fields"].length).fill(SEPARATOR).join("")
                    } else {
                        field['sub-fields'].forEach((fieldTable) => {
                            if (formField.value[i] == undefined) {
                                this.csv += ";"
                            } else {
                                let tableField = formField.value[i].results.find(subRec => subRec.order == fieldTable.order)
                                this.csv += this.getFieldResult(tableField)
                            }
                        })
                    }
                }
            })
            this.csv = this.csv.substring(0, this.csv.length - 1)
            this.csv += LINE_BREAK
        }
        return this
    }

    getCustomFieldResult(deep, formField) {
        if (deep > 0) {
            return SEPARATOR
        }
        return this.getFieldResult(formField)
    }

    getFieldResult(formField) {
        if (formField.type == fieldType.SIGNATURE)
            return "[PODPIS]" + SEPARATOR
        if (formField.type == fieldType.PHOTO)
            return "[PHOTO]" + SEPARATOR
        if (formField.type == fieldType.RADIO)
            return (formField && formField.value) ? formField.predefined[formField.value - 1] + SEPARATOR : "" + SEPARATOR
        if (formField.type == fieldType.CHECKBOX) {
            let res = "";
            (formField && formField.value) ? formField.value.forEach(el => res += formField.predefined[el - 1] + " ") + SEPARATOR : "" + SEPARATOR
            return res
        }
        if (formField.type == fieldType.MULTIPLE) {
            return (formField.value) ? (formField.value.filter(el => el != "").join('$#-SEP-#$ ').split(",").join(".")
                .split(';').join('|').split('$#-SEP-#$').join(",")) + SEPARATOR : i18n.t('base.no-data')
        }
        return (formField.value == undefined || formField.value == 'null') ? "" + SEPARATOR : formField.value + SEPARATOR
    }

    getMaxDeph(form) {
        let deep = 1
        form.results.forEach(result => {
            if (result.type == fieldType.TABLE) {
                deep = result.value.length > deep ? result.value.length : deep
            }
        })
        return deep
    }

    printHeaders() {
        this.schema.fields.forEach(field => {
            if (field.type == fieldType.TABLE)
                field['sub-fields'].forEach(fieldTable => {
                    this.csv += field.name + " - " + fieldTable.name + SEPARATOR
                })
            else {
                this.csv += field.name + SEPARATOR
            }
        })
        this.csv = this.csv.substring(0, this.csv.length - 1) + LINE_BREAK
        return this
    }
}